var $54b47fc030b7b21e$exports = {};
// console.log("okey");
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll(".carousel").forEach((carousel)=>{
        new Flickity(carousel, {
            cellAlign: "center",
            contain: true,
            wrapAround: true,
            pageDots: true,
            prevNextButtons: true
        });
    });
});


//# sourceMappingURL=index.a686f25f.js.map
